import SearchIcon from "@material-ui/icons/Search"
import classnames from "classnames"
import React, { useState } from "react"
import { useDisplayIcon } from "../../../actions/useDisplayIcon"
import styles from "./SearchInput.module.scss"

export const SearchInput = ({ onChange, searchPlaceholder }) => {
  const [query, setQuery] = useState("")
  const display = useDisplayIcon()
  const onUpdateInput = () => onChange(query)

  return (
    <div className="position-relative">
      <input
        className={classnames(
          "form-control form-control-sm mr-3 w-100 d-flex justify-content-center",
          styles.input,
        )}
        type="text"
        placeholder={searchPlaceholder}
        aria-label={searchPlaceholder}
        onChange={(e) => setQuery(e.target.value)}
        onKeyPress={(event) => {
          if (event.key === "Enter") onUpdateInput()
        }}
      />
      <SearchIcon
        className={classnames(styles["search-icon"], "cursor-pointer")}
        style={{ display }}
        onClick={onUpdateInput}
      />
    </div>
  )
}
